require('gsap');

var $ = require('jquery');
var cymasmooth = require('cymasmooth');

var site = require('./site.js');
var revealManager = require('./anims/0reveals-manager.js');

var pageInit = function(next) {
	site.unfreezeUI();
	site.initPage( next );
};

var first_loading = true;
var old = false;
var next = false;
var hideAnim = function(next_page, prev_page){
	console.log('prev_page', prev_page);
	console.log('next_page', next_page);
	
	old = $(this.contentQuery).get();
	next = old;
	if ( prev_page && prev_page.model ) {
		console.log('createAnimNextDiv');
		next = createAnimNextDiv( next_page.div );
		$(old).find('.scroll-reveal').addClass('is-disabled');
	}
	else {
		old = $('<div/>');
	}
	$(window).trigger('resize');

	var tl = new TimelineMax({
		paused : true,
		onComplete: function(){
		}
	})
	tl.addLabel('prestart', 0);
	tl.add( function(){
		// alert('b')
		$(next).get(0).offsetWidth;
		$(window).trigger('resize');
		
	}, 'prestart+=0.1' );
	tl.add( getShowNextPageAnim( next, old, this.actionfrombrowser, prev_page, next_page ), '+=0.005' );
	return tl;
};

// var cymasmooth.savedScroll = {};
var first__try = true;
// var previousTeamOpenIndex = -1;
// var previousCaseStudyIndex = -1;
var previousBiensIndex = -1;
var previousOffresIndex = -1;
var previousNewsIndex = -1;
var getShowNextPageAnim = function(el, old, actionFromBrowser, prev_page, next_page){
	console.log('scrollnav manager : actionFromBrowser', actionFromBrowser);
	// alert('sksmooth anim scroll to')
	var final_scrolltop = 0;
	if ( actionFromBrowser == false ) {
		var key = prev_page.url;
		key = cymasmooth.urls[cymasmooth.urls.length - 2];
		console.log('scrollnav manager : key saved : ', key);
		cymasmooth.savedScroll[key] = $(window).scrollTop();
		console.log('scrollnav manager : cymasmooth.savedScroll', cymasmooth.savedScroll);
	}
	else { // clicked on previous page button in browser
		// if ( cymasmooth.savedScroll[next_page.url] && cymasmooth.savedScroll[next_page.url] > 0 && cymasmooth.prev_page && cymasmooth.next_page && cymasmooth.prev_page.model == 'news-detail' && cymasmooth.next_page.model == 'news' ) {
		// 	final_scrolltop = cymasmooth.savedScroll[next_page.url];
		// }
	}
	// save home slide position and assign back link the home url
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'home' && cymasmooth.next_page && cymasmooth.next_page.model == 'bien' ) {
		// change "back" link to home url
		console.log('scrollnav manager : from home to bien detail');
		var swiper = $(old).find('.home__cessions__group__cessions__items__wrap').get(0).swiperInstance;
		previousBiensIndex = swiper.realIndex;
		console.log('scrollnav manager : previousBiensIndex saved : ', previousBiensIndex);
		$('.asteren__back__link').attr('href', cymasmooth.prev_page.url);
	}
	// load slide position and set page scroll position to previous one
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'bien' && cymasmooth.next_page && cymasmooth.next_page.model == 'home' ) {
		// check if this is the back button which was clicked
		console.log('scrollnav manager : last_nav_el_clicked', cymasmooth.last_nav_el_clicked);
		if ( actionFromBrowser || $(cymasmooth.last_nav_el_clicked).hasClass('asteren__back__link') ){
			console.log('scrollnav manager : back link clicked from bien detail');
			if ( previousBiensIndex > 0 ){
				$(el).find('.home__cessions__group__cessions__items__wrap').attr('data-start-index', previousBiensIndex);
				console.log('scrollnav manager : previousBiensIndex loaded : ' + previousBiensIndex);
				previousBiensIndex = -1;
			}
			final_scrolltop = cymasmooth.savedScroll[next_page.url];
		}
	}
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'biens' && cymasmooth.next_page && cymasmooth.next_page.model == 'bien' ) {
		// change "back" link to real previous url
		console.log('scrollnav manager : from biens to bien detail');
		$('.asteren__back__link').attr('href', cymasmooth.urls[cymasmooth.urls.length - 2]);
	}
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'bien' && cymasmooth.next_page && cymasmooth.next_page.model == 'biens' ) {
		// check if this is the back button which was clicked
		console.log('scrollnav manager : last_nav_el_clicked 2', cymasmooth.last_nav_el_clicked);
		if ( actionFromBrowser || $(cymasmooth.last_nav_el_clicked).hasClass('asteren__back__link') ){
			console.log('scrollnav manager : back link clicked from bien detail 2');
			var offset = actionFromBrowser ? 2 : 1;
			var key = cymasmooth.urls[cymasmooth.urls.length - offset];
			console.log('scrollnav manager : key loaded : ', key);
			final_scrolltop = cymasmooth.savedScroll[key];
		}
	}
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'procedures' && cymasmooth.next_page && cymasmooth.next_page.model == 'procedure' ) {
		// change "back" link to real previous url
		console.log('scrollnav manager : from procedures to procedure detail');
		$('.asteren__back__link').attr('href', cymasmooth.urls[cymasmooth.urls.length - 2]);
	}
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'procedure' && cymasmooth.next_page && cymasmooth.next_page.model == 'procedures' ) {
		// check if this is the back button which was clicked
		console.log('scrollnav manager : last_nav_el_clicked 2', cymasmooth.last_nav_el_clicked);
		if ( actionFromBrowser || $(cymasmooth.last_nav_el_clicked).hasClass('asteren__back__link') ){
			console.log('scrollnav manager : back link clicked from procedure detail 2');
			var offset = actionFromBrowser ? 2 : 1;
			var key = cymasmooth.urls[cymasmooth.urls.length - offset];
			console.log('scrollnav manager : key loaded : ', key);
			final_scrolltop = cymasmooth.savedScroll[key];
		}
	}

	// if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'offrespost-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'rejoindre' ) {
	// 	console.log('scrollnav manager : back from offre detail', cymasmooth.last_nav_el_clicked);
	// 	if ( $(cymasmooth.last_nav_el_clicked).hasClass('headerpagesml__back__link') ){
	// 		final_scrolltop = cymasmooth.savedScroll[next_page.url];
	// 	}
	// }

	// save home slide position and assign back link the home url
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'rejoindre' && cymasmooth.next_page && cymasmooth.next_page.model == 'offrespost-detail' ) {
		var swiper = $(old).find('.rejoindre__offres__group__liste__items__wrap').get(0).swiperInstance;
		previousOffresIndex = swiper.realIndex;
		console.log('scrollnav manager : previousOffresIndex saved : ', previousOffresIndex);
	}
	// load slide position and set page scroll position to previous one
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'offrespost-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'rejoindre' ) {
		// check if this is the back button which was clicked
		console.log('scrollnav manager : last_nav_el_clicked', cymasmooth.last_nav_el_clicked);
		if ( actionFromBrowser || $(cymasmooth.last_nav_el_clicked).hasClass('headerpagesml__back__link') ){
			console.log('scrollnav manager : back link clicked from offre detail');
			if ( previousOffresIndex > 0 ){
				$(el).find('.rejoindre__offres__group__liste__items__wrap').attr('data-start-index', previousOffresIndex);
				console.log('scrollnav manager : previousOffresIndex loaded : ' + previousOffresIndex);
				previousOffresIndex = -1;
			}
			final_scrolltop = cymasmooth.savedScroll[next_page.url];
		}
	}

	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'news' && cymasmooth.next_page && cymasmooth.next_page.model == 'news' ) {
		console.log('scrollnav manager : news to news');
		if ( cymasmooth.next_page.url.indexOf('pagenb') > 0 ) {
			var st = $(el).find('.news__affichage__content__anchor').offset().top;
			console.log('scrollnav manager : st', st, $(el).offset().top, $(el).find('.news__header').height());
			var page_offset = $(el).offset().top;
			console.log('scrollnav manager : page_offset', page_offset);
			final_scrolltop = st - page_offset;
		}
	}

	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'news' && cymasmooth.next_page && cymasmooth.next_page.model == 'news-detail' ) {
		console.log('scrollnav manager : news to news');
		$('.asteren__back__link, .headerpagesml__back__link').attr('href', cymasmooth.urls[cymasmooth.urls.length - 2]);
	}

	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'news-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'news' ) {
		console.log('scrollnav manager : back link clicked from news detail to home list');
		var offset = actionFromBrowser ? 2 : 1
		var key = cymasmooth.urls[cymasmooth.urls.length - offset];
		console.log('scrollnav manager : key loaded : ', key);
		final_scrolltop = cymasmooth.savedScroll[key];
	}

	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'home' && cymasmooth.next_page && cymasmooth.next_page.model == 'news-detail' ) {
		var swiper = $(old).find('.home__actualites__group__actualites__items__wrap').get(0).swiperInstance;
		previousNewsIndex = swiper.realIndex;
		console.log('scrollnav manager : previousNewsIndex saved : ', previousNewsIndex);
		$('.asteren__back__link, .headerpagesml__back__link').attr('href', cymasmooth.urls[cymasmooth.urls.length - 2]);
	}

	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'news-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'home' ) {
		if ( actionFromBrowser || ( $(cymasmooth.last_nav_el_clicked).hasClass('headerpagesml__back__link') || $(cymasmooth.last_nav_el_clicked).hasClass('asteren__back__link') ) ){
			console.log('scrollnav manager : back link clicked from news detail to home');
			if ( previousNewsIndex > 0 ){
				$(el).find('.home__actualites__group__actualites__items__wrap').attr('data-start-index', previousNewsIndex);
				console.log('scrollnav manager : previousNewsIndex loaded : ' + previousNewsIndex);
				previousNewsIndex = -1;
			}
			final_scrolltop = cymasmooth.savedScroll[next_page.url];
		}
	}

	// QUENTIN WEBER

	// from histoire detail to home, 
	// need to store the scroll offset from the home page ONLY if going tfrom home to histoire detail, every other from to erase the stored data so we only use it on thoses templates -> home -> histoire detail -> home
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'histoirespost-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'home' ) {
		if ( actionFromBrowser || ( $(cymasmooth.last_nav_el_clicked).hasClass('theme__histoire__retour__cta__label') || $(cymasmooth.last_nav_el_clicked).hasClass('theme__histoire__retour__cta__b') ) ){
			console.log('scrollnav manager : back link clicked from histoire detail to home');
			// if ( previousNewsIndex > 0 ){
			// 	$(el).find('.home__actualites__group__actualites__items__wrap').attr('data-start-index', previousNewsIndex);
			// 	console.log('scrollnav manager : previousNewsIndex loaded : ' + previousNewsIndex);
			// 	previousNewsIndex = -1;
			// }
			final_scrolltop = cymasmooth.savedScroll[next_page.url];
			console.log('scrollnav manager : back link clicked from histoire detail to home final_scrolltop', final_scrolltop);
		}
	}

	// from histoire detail to histoires
	// everytime we do this move we update so that current histoire in histoires is the last histoire detail shown
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'histoirespost-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'histoires' ) {
		if ( actionFromBrowser || ( $(cymasmooth.last_nav_el_clicked).hasClass('theme__histoire__retour__cta__label') || $(cymasmooth.last_nav_el_clicked).hasClass('theme__histoire__retour__cta__b') ) ){
			console.log('scrollnav manager : back link clicked from histoire detail to histoires');
			var id = $(old).find('[data-histoire-id]').attr('data-histoire-id');
			console.log('scrollnav manager : id', id);
			$(el).attr('data-previous-detail', id);
		}
	}

	// we need to create to "back" cta on the histoire detail page, one to the histoires list, one to the home, default to the histoires, to home only if coming from home
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'home' ) {
		$(el).addClass('coming-from-home');
	}

	console.log('scrollnav manager : cymasmooth.prev_page', cymasmooth.prev_page);
	console.log('scrollnav manager : cymasmooth.next_page', cymasmooth.next_page);
	console.log('scrollnav manager : cymasmooth.urls', cymasmooth.urls);
	console.log('scrollnav manager : cymasmooth.last_nav_el_clicked.className', cymasmooth.last_nav_el_clicked.className);
	// force nav to go to actus blocs if coming from news detail and click on back in the browser, final action is done in site.js
	// if ( actionFromBrowser && cymasmooth.prev_page && cymasmooth.next_page && cymasmooth.prev_page.model == 'news-detail' && cymasmooth.next_page.model == 'home' ) {
	// 	cymasmooth.gotopagewithanchor = 'actualites';
	// }
	// if ( cymasmooth.prev_page && cymasmooth.prev_page.model && cymasmooth.next_page && cymasmooth.next_page.model == 'casestudypost-detail' ) {
	// 	var swiper = $(old).find('.casestudy__slide__items__wrap').get(0).swiperInstance;
	// 	previousCaseStudyIndex = swiper.realIndex;
	// }
	// if ( cymasmooth.gotopagewithanchor == 'casestudyanchor' && previousCaseStudyIndex > -1 ){
	// 	$(el).find('.casestudy__slide__items__wrap').attr('data-start-index', previousCaseStudyIndex);
	// 	previousCaseStudyIndex = -1;
	// }
	// if ( actionFromBrowser && cymasmooth.prev_page.model == 'casestudypost-detail' && cymasmooth.next_page.model != 'casestudypost-detail' && previousCaseStudyIndex > -1 ){
	// 	$(el).find('.casestudy__slide__items__wrap').attr('data-start-index', previousCaseStudyIndex);
	// 	previousCaseStudyIndex = -1;
	// 	final_scrolltop = cymasmooth.savedScroll[next_page.url];
	// }
	

	// SERAU
	// from projet detail to projets listing
	if ( cymasmooth.prev_page && cymasmooth.prev_page.model == 'projetspost-detail' && cymasmooth.next_page && cymasmooth.next_page.model == 'projets' ) {
		if ( actionFromBrowser || ( $(cymasmooth.last_nav_el_clicked).hasClass('projetspost__back') || $(cymasmooth.last_nav_el_clicked).hasClass('projetspost__back') ) ){
			console.log('scrollnav manager : back link clicked from projet detail to projets listing');
			final_scrolltop = cymasmooth.savedScroll[next_page.url];
		}
	}

	// if ( cymasmooth.savedScroll[next_page.url] 
	// 	&& cymasmooth.prev_page 
	// 	&& cymasmooth.next_page.model == 'news' 
	// 	&& cymasmooth.prev_page.model == 'news-detail' ){
	// 	final_scrolltop = cymasmooth.savedScroll[next_page.url];
	// }
	// if ( cymasmooth.savedScroll[next_page.url] 
	// 	&& cymasmooth.prev_page 
	// 	&& cymasmooth.next_page.model == 'projets' 
	// 	&& cymasmooth.prev_page.model == 'projetpost-detail' ){
	// 	final_scrolltop = cymasmooth.savedScroll[next_page.url];
	// }
	if ( cymasmooth.gotopagewithanchor ) {
		var anchor = cymasmooth.gotopagewithanchor + '';
		if ( $(el).find('#'+anchor).length ){
			var st = $(el).find('#'+anchor).offset().top;
			final_scrolltop = st;
			console.log('debug anchor first st', st);
			console.log('scrollnav manager : infoooooooooooooooooooooooooooos', st, $(el).offset().top);
			var page_offset = $(el).offset().top;
			console.log('debug anchor scrollnav manager : page_offset', page_offset);
			final_scrolltop = final_scrolltop - page_offset;
			cymasmooth.finalscrolltop = final_scrolltop;
			console.log('debug anchor second cymasmooth.finalscrolltop', cymasmooth.finalscrolltop);
			console.log('debug anchor test', $(el).offset().top, $(el).find('.home__intro__section').offset().top, $(el).find('.home__intro__section').offset().top);
			cymasmooth.gotopagewithanchor = false;
		}
	}
	console.log('debug anchor third cymasmooth.finalscrolltop', cymasmooth.finalscrolltop);
	cymasmooth.finalscrolltop = final_scrolltop;
	console.log('scrollnav manager : final_scrolltop !!!!!!!!!!!!!!!', final_scrolltop);
	// console.log('final_scrolltop fixed !!!!!!!!!!!!!!!', final_scrolltop - $(el).offset().top);
	$(el).css({
		top: -final_scrolltop + "px"
	});
	var timeline = new TimelineMax({
		// paused: true
	});
	timeline.addLabel('getShowNextPageAnim0');
	timeline.add(function(){
		$(el).css({visibility:'visible'});
	}, 'getShowNextPageAnim0');
	var appear_duration = 0.007;
	// timeline.to(el, appear_duration, {
	// 	opacity: 1
	// }, 'getShowNextPageAnim0');
	
	// timeline.to(old, appear_duration, {
	// 	opacity: 0
	// }, 'getShowNextPageAnim0');
	
	// if ( first_loading ) {
	// 	timeline.to($('[data-js="site-loader"]'), 0.007, {
	// 		opacity: 0
	// 	}, 'getShowNextPageAnim0');
	// }
	timeline.addLabel('getShowNextPageAnim');
	// timeline.to(window, 0, {
	// 	scrollTo: 0
	// }, 'getShowNextPageAnim');
	timeline.add(function(){
		// alert('sk smooth set scroll')
		// debugger;
		$('html, body').scrollTop(final_scrolltop);
		// debugger;
		if ( $('.services__content').length ){
			console.log('service--content__b', $('.services__content').get(0).innerHTML);
		}
	}, 'getShowNextPageAnim');
	timeline.add(function(){
		$(window).trigger('sksmoothanim:nextPageCreated', el);
	}, 'getShowNextPageAnim');
	return timeline;
	// pourquoi ce bloc en dessous, alors qu'il est deja a la fin de la main anim plus bas
	timeline.add(function(){
		$('html, body').scrollTop(final_scrolltop);
		// if ( !first__try ) {
			$(old).remove();
		// }
		// else {
		// 	first__try = false;
		// }
		$('.pw__dummy').remove();
		$(el).attr('style','').css({position:'relative'});
		$(window).trigger('page-is-relative');
	}, 'getShowNextPageAnim');
	// first__try = false;
	return timeline;
};

var createAnimNextDiv = function( el ){
	return $( el ).clone().css({
		opacity: 0,
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		// visibility: 'visible',
		zIndex: 5
	}).appendTo($('[data-js="content-wrap"]')).get(0);
};

var createAnimTimeline = function( el ){
	return new TimelineMax({
		paused : true,
		onComplete: function(){
			$('[data-js="site-loading"]').remove();
			$('[data-js="site-loader"]').remove();
			$('.trans-mover').remove();
			// $( '.link-with-mover-effect' ).removeClass( 'link-with-mover-effect' );
			console.log('on complete final');
			// $(old).remove();
			// alert('done')
			// TweenMax.set(next, {'className':'-=is-hidden',clearProps:'all'});
			// TweenMax.set($('.page__rect__mover').get(0), {'className':'-=is-hidden',clearProps:'all'});
		}
	});
};

var showCount = 0;
var showAnim = function(next_page, prev_page){
	var tl = createAnimTimeline();
	tl.add(function(){
		$(window).trigger('sksmooth:showAnimStart', next);
	});
	tl.addLabel('prestart', 0);
	tl.add( function(){
		// alert('b')
		$(next).get(0).offsetWidth;
		$(window).trigger('resize');
	}, 'prestart+=0.1' );
	// return tl;
	tl.addLabel('transstart', 'prestart+=0.2' );

	console.log('this.actionfrombrowser', this.actionfrombrowser);

	// tl.add( getShowNextPageAnim( next, old, this.actionfrombrowser, prev_page, next_page ), '+=0.005' );

	// tl.add(function(){
	// 	pageInit(next);
	// 	// $(window).trigger('sticky:resize');
	// }, '+=0.1');

	tl.addLabel('nextmainpartstart', 0.2 );
	tl.addLabel('nextmainpartstartb', 0.6 );
	tl.addLabel('nextmainpartstartc', 1.6 );


	var animDecal = 'nextmainpartstart';
	var nextmainpageinitDelay = 0.7;
	if ( showCount > 0 ){
		// tl.to( $(old), 0.4, {
		// 	opacity: 0
		// }, 'nextmainpartstart' );
		animDecal = 'nextmainpartstart';
		nextmainpageinitDelay = 0.5;
	}
	tl.addLabel('nextmainpageinit', nextmainpageinitDelay);
	if ( next_page.model == 'histoires' ){
		animDecal = 'nextmainpartstartc';
	}
	tl.add(function(){
		// debugger;
	}, 'nextmainpartstart')
	var fadeDuration = showCount > 0 ? 0.4 : 1.8;
	tl.to( $(next), fadeDuration, {
		opacity: 1,
		ease: 'none',
	}, 'nextmainpartstart' );

	var model = next_page.model;
	if ( model != 'home' ) {
		model = 'home';
	}
	tl.add( function(){
		$('body').removeClass('body__'+prev_page.model).addClass('body__'+next_page.model);
		$(window).trigger('sksmoothanim:nextPageFadeStart', [next, showCount]);
	// }, animDecal+'+=0.1' );
	}, 'nextmainpartstart' );

	var showCountTemp = showCount;

	tl.add(function(){
		pageInit(next);
		$(window).trigger('sksmoothanim:showAnim', [next, next_page, showCountTemp]);
	// }, animDecal+'+=0.05');
	}, 'nextmainpageinit');
	// var has_reveal = revealManager( model + 'modelanim', $(next), tl, 'nextmainpartstart' );
	var has_reveal = revealManager( 'homemodelanim', $(next), tl, animDecal );

	tl.add(function(){
		if ( showCountTemp > 0 ){
			// return;
		}
		// debugger;
		$(old).remove();
		$('.pw__dummy').remove();
		$('.page__wrap__fixed').remove();
		$(next).css({position:'relative',zIndex:'auto','top':0});
		if ( cymasmooth.finalscrolltop ){
			console.log('debug anchor final cymasmooth.finalscrolltop', cymasmooth.finalscrolltop);
			$('html, body').scrollTop(cymasmooth.finalscrolltop);
			cymasmooth.finalscrolltop = false;
			// debugger;
		}

		if ( $('[data-js="content-wrap"] .page__wrap ').size() > 1 ) {
			var total = $('[data-js="content-wrap"] .page__wrap ').size() - 1;
			for(var i=0;i<total;i++){
				$('[data-js="content-wrap"] .page__wrap ').eq(0).remove();
			}
		}
		$(window).trigger('cymasmooth:finalPageWrapPlaced');
		$('.is-clicked').removeClass('is-clicked');
		// alert('y')
	}, 'nextmainpartstart+='+fadeDuration);
	// }, '+=0.1');
	showCount++;
	return tl;
};


var f = function() { return false; };

cymasmooth.registerAnim('show', showAnim);
cymasmooth.registerAnim('hide', hideAnim);

